import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const JoinersLeaversChart = () => {
	const options = {
		chart: {
			type: "spline",
			height: 300,
			scrollablePlotArea: {
				scrollPositionX: 1,
			},
			style: {
				fontSize: "16px",
			},
		},
		title: {
			text: "",
			align: "left",
		},
		xAxis: {
			type: "datetime",
			labels: {
				overflow: "justify",
			},
		},
		yAxis: {
			title: { text: null },
			minorGridLineWidth: 0,
			gridLineWidth: 0,
			alternateGridColor: null,
			labels: {
				format: "{value}",
			},
			opposite: false,
		},

		tooltip: {
			valueSuffix: "",
		},
		plotOptions: {
			spline: {
				lineWidth: 4,
				states: {
					hover: {
						lineWidth: 5,
					},
				},
				marker: {
					enabled: false,
				},
			},
		},
		legend: {
			enabled: true,
			useHTML: true,
			labelFormatter: function () {
				// Custom HTML for legend item
				return `<div style="background-color: ${this.color}; padding: 5px; border-radius: 5px"><span class="legend-item" style=" color: white;">${this.name}</span></div<`;
			},
			align: "center",
			verticalAlign: "bottom",
			layout: "horizontal",
			symbolHeight: 0,
			symbolWidth: 0,
			y: 0,
			x: 30,
			itemStyle: {
				fontSize: "12px",
				fontWeight: "600",
			},
		},
		series: [
			{
				name: "Joiners",
				data: [
					[Date.UTC(2024, 0, 1), 5.4],
					[Date.UTC(2024, 1, 1), 5.2],
					[Date.UTC(2024, 2, 1), 5.7],
					[Date.UTC(2024, 3, 1), 6.3],
					[Date.UTC(2024, 4, 1), 5.2],
					[Date.UTC(2024, 5, 1), 5.6],
					[Date.UTC(2024, 6, 1), 6.1],
					[Date.UTC(2024, 7, 1), 5.6],
					[Date.UTC(2024, 8, 1), 5.9],
					[Date.UTC(2024, 9, 1), 7.1],
					[Date.UTC(2024, 10, 1), 8.6],
					[Date.UTC(2024, 11, 1), 7.8],
				],
				type: "areaspline",
				lineWidth: 2.5,
				fillOpacity: 0.1,
				color: "#ea611c",
				marker: {
					enabled: false,
				},
			},
			{
				name: "Leavers",
				data: [
					[Date.UTC(2024, 0, 1), 2],
					[Date.UTC(2024, 1, 1), 3],
					[Date.UTC(2024, 2, 1), 1],
					[Date.UTC(2024, 3, 1), 4],
					[Date.UTC(2024, 4, 1), 5],
					[Date.UTC(2024, 5, 1), 5],
					[Date.UTC(2024, 6, 1), 6],
					[Date.UTC(2024, 7, 1), 5],
					[Date.UTC(2024, 8, 1), 5],
					[Date.UTC(2024, 9, 1), 7],
					[Date.UTC(2024, 10, 1), 8],
					[Date.UTC(2024, 11, 1), 6],
				],
				type: "areaspline",
				lineWidth: 2.5,
				fillOpacity: 0.1,
				color: "#FF0000",
				marker: {
					enabled: false,
				},
			},
		],
		navigation: {
			menuItemStyle: {
				fontSize: "10px",
			},
		},
		credits: {
			enabled: false,
		},
	};

	return (
		<div className="width-full">
			<HighchartsReact
				highcharts={Highcharts}
				options={options}
			/>
		</div>
	);
};

export default JoinersLeaversChart;
